var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div tabindex=\"0\" class=\"alert alert-info\" ng-show=\"$tzCtrl.is_time_zone_diff\" translate=\"I18N.TIMEZONE.TIMEZONE_INFO\" translate-values=\"{time_zone_name: $tzCtrl.time_zone_name}\">\n</div>";
var id1="core/time-zone/time_zone.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/core/time-zone/time_zone.html
// module id = 1163
// module chunks = 0